import 'angular';

import { RepcoStates }       from './repco.states.ajs';
import { RepcoSettingsCtrl } from './repco.settings';

angular.module('workshop.repco', [])
  .config(RepcoStates)
  .controller('RepcoSettingsCtrl', RepcoSettingsCtrl);
